import { useNavigate } from "react-router-dom"
import FAQs from "../../../assets/images/UserPortal/FAQs.png"
import ContactUs from "../../../assets/images/UserPortal/contact-us.png"

const CustomerServicesSection = () => {

  const navigate = useNavigate()

  return (
    <div className="m-3">
      <div className="fw-semibold fs-4 mb-3">Customer Services</div>

      <div className="d-flex gap-5">
        <div className="d-flex flex-column align-items-center justify-content-between cursor-pointer" onClick={() => navigate('/customer-services')}>
          <div>
            <img src={FAQs} alt="" />
          </div>
          <div className="fw-semibold fs-4">FAQ’s</div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-between cursor-pointer" onClick={() => navigate('/contact-us')}>
          <div>
            <img src={ContactUs} alt="" />
          </div>
          <div className="fw-semibold fs-4">Contact Us</div>
        </div>
      </div>
    </div>
  )
}

export default CustomerServicesSection
